import { render, staticRenderFns } from "./ModalConfirmacaoLocal.vue?vue&type=template&id=1bcfd9c8&scoped=true&"
import script from "./ModalConfirmacaoLocal.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmacaoLocal.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfirmacaoLocal.vue?vue&type=style&index=0&id=1bcfd9c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcfd9c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
